<div class="wrapper">
    <div class="position-relative">
        <seech-combo-select #locationInput [results]="results" [id]="id" [placeHolder]="placeholder"
            [maxRowCount]="maxRowCount" [autoSelect]="autoSelect" controlType="location" [label]="label"
            (selectionLimitReached)="onSelectionLimitReached($event)" [inputValue]="value"
            (chipsDeleteChange)="emitChanges($event)" [maxSelectionCount]="maxSelectionCount" [chipsColor]="chipsColor"
            [readonly]="readonly" [disabled]="disabled" [emptyStateText]="emptyStateText">
        </seech-combo-select>
    </div>
</div>